import request from '@/utils/request.js'

// 资质管理-区域下拉列表查询
export const getZoneList = () => {
  return request({
    url: '/test/zoneInfo/getList',
    method: 'get',
  })
}

//资质管理-测试线路下拉列表查询
export const getListByZoneType = () => {
    return request({
      url: '/test/zoneDetailInfo/getListByZoneType',
      method: 'get',
    })
  }

//材料模板通用查询接口
export const getListByCondition = (data) => {
    return request({
      url: '/material/templateInfo/getListByCondition',
      method: 'post',
      data: data
    })
  }

//资质管理-人员下拉列表
export const getPersonListByCondition = (data) => {
    return request({
      url: '/person/manage/getListByCondition',
      method: 'post',
      data: data
    })
  }
  
  //区域-线路 联动/test/zoneInfo/getZoneDetailTreeByType
  export const getZoneDetailTreeByType = (data) => {
    return request({
      url: '/test/zoneInfo/getZoneDetailTreeByType',
      method: 'get',
      params: data
    })
  }


  
//资质管理-测试有效期校验
export const checkTestDate = (data) => {
    return request({
      url: '/car/qualificationInfo/checkTestDate',
      method: 'post',
      data: data
    })
  }

  //资质管理-测试类型校验
export const checkTestType = (data) => {
  return request({
    url: '/car/qualificationInfo/checkTestType',
    method: 'post',
    data: data
  })
}


 //资质管理-新增
  export const qualificationAdd = (data) => {
    return request({
      url: '/car/qualificationInfo/insert',
      method: 'post',
      data: data
    })
  }

  //资质管理-查询车辆
  export const selectListByNum = (data) => {
    return request({
      url: '/cloud/carInfoEntity/selectListByNum',
      method: 'get',
      params: data
    })
  }

  
  //资质管理-列表查询
  export const qualificationList = (data) => {
    return request({
      url: '/car/qualificationInfo/getPagesByCondition',
      method: 'post',
      data: data
    })
  }

//资质管理-列表查询 v2
export const qualificationList2 = (data) => {
  return request({
    url: '/car/qualificationInfo/getPagesByCondition2',
    method: 'post',
    data: data
  })
}


  //资质材料详情
  export const getMaterialList = (data) => {
    return request({
      url: '/car/qualifications/checkMaterial/getListByCondition',
      method: 'post',
      data: data
    })
  }

  //资质主体详情
  export const getQualificationInfoDetail = (data) => {
    return request({
      url: '/car/qualificationInfo/getQualificationInfoDetail',
      method: 'get',
      params: data
    })
  }

  //详情  资质审批结果
  export const getQualificationCheckResults = (data) => {
    return request({
      url: '/car/qualificationInfo/getQualificationCheckResults',
      method: 'get',
      params: data
    })
  }

 //  资质编辑
  export const qualificationEdit = (data) => {
    return request({
      url: '/car/qualificationInfo/updateEntityAndRels',
      method: 'post',
      data: data
    })
  }

  //材料单个保存/car/qualifications/checkMaterial/updateById
  export const fileUpdateById = (data) => {
    return request({
      url: '/car/qualifications/checkMaterial/updateById',
      method: 'post',
      data: data
    })
  }


//资质管理-撤销资质申请
  export const deleteEntityAndRels = (data) => {
    return request({
      url: '/car/qualificationInfo/deleteEntityAndRels',
      method: 'get',
      params: data
    })
  }

  //资质管理-延期申请校验
export const checkQualificationDate = (data) => {
  return request({
    url: '/car/qualificationDelayRecord/checkQualificationDate',
    method: 'get',
    params: data
  })
}

//资质管理-延期记录
export const getDelayRecordsByQualificationId = (data) => {
  return request({
    url: '/car/qualificationDelayRecord/getDelayRecordsByQualificationId',
    method: 'get',
    params: data
  })
}

//资质管理-延期申请新增
 export const qualificationDelayApply = (data) => {
  return request({
    url: '/car/qualificationDelayRecord/insert',
    method: 'post',
    data: data
  })
}


//资质管理-延期申请审核分页列表
export function qualificationDelayList(data) {
  return request({
    url: "/car/qualificationDelayRecord/getPagesByCondition",
    method: "post",
    data: data,
  });
}

//资质管理-延期详情（缺少若依调用查询审批人信息）
export function qualificationDelayDetail(data) {
  return request({
    url: "/car/qualificationDelayRecord/detail",
    method: "get",
    params:data
  });
}

//资质管理-延期申请审核(需存储若依用户id)
export function qualificationDelayAuditing(data) {
  return request({
    url: "/car/qualificationDelayRecord/updateCheck",
    method: "post",
    data: data,
  });
}


///资质管理-开始审核
export function startCheckMaterial(data) {
  return request({
    url: "/car/qualifications/checkMaterial/startCheckMaterial",
    method: "get",
    params: data,
  });
}

///资质管理-材料审核
export function updateQualificationMateriaCheckInfo(data) {
  return request({
    url: "/car/qualifications/checkMaterial/updateQualificationMateriaCheckInfo",
    method: "post",
    data: data,
  });
}



// 资质管理-专家组审核
export function checkQualificationInfo(data) {
  return request({
    url: "/car/qualificationInfo/checkQualificationInfo",
    method: "post",
    data: data,
  });
}

//即将到期资质统计
export function qualificationCount() {
  return request({
    url: '/car/qualificationInfo/count',
    method: 'get'
  })
}
